import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation, Manipulation } from 'swiper/modules';

export class Slider {
    constructor(selector, options) {

        this.selector = selector;

        if ((typeof options !== 'undefined' && options.forceInit) || $(this.selector).find('.slide').length > 1) {
            $(this.selector).wrapInner('<div class="swiper-wrapper"></div>');
            $(this.selector).append('<div class="swiper-pagination"></div>');
            $(this.selector).find('.slide').wrap('<div class="swiper-slide"></div>');

            this.slider = new Swiper(selector, Object.assign({
                loop: true,
                lazy: true,
                slidesPerView: 1,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: true,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                modules: [Autoplay, Pagination, Navigation, Manipulation]
            }, options));
        }

    }
}